import { motion } from 'motion/react';
import { Button } from './ui/button';
import { Cpu, Zap, Target } from 'lucide-react';

interface HeroProps {
  onExploreCourses: () => void;
}

export function Hero({ onExploreCourses }: HeroProps) {
  const features = [
    { icon: Cpu, title: 'Industry-Ready Curriculum' },
    { icon: Zap, title: 'Hands-on Edge Labs' },
    { icon: Target, title: 'Deployable Capstone Projects' },
  ];

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center py-6 px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-center max-w-4xl"
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="mb-6"
        >
          <h1 className="text-white mb-4">
            Comprehensive Path to Professional Edge AI & IoT
          </h1>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
          className="text-cyan-300 mb-12 text-xl"
        >
          Master the full stack — from sensors to silicon, from embedded
          firmware to AI inference.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 1.1 }}
        >
          <Button
            onClick={onExploreCourses}
            size="lg"
            className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-8 py-6 rounded-full shadow-lg"
            style={{
              boxShadow: '0 0 30px rgba(0, 229, 209, 0.5)',
            }}
          >
            Explore Courses
          </Button>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.3 }}
        className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl w-full"
      >
        {features.map((feature, index) => (
          <motion.div
            key={feature.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1.5 + index * 0.2 }}
            className="flex flex-col items-center gap-3 p-6 rounded-xl"
            style={{
              background: 'rgba(15, 35, 60, 0.5)',
              border: '1px solid rgba(0, 229, 209, 0.2)',
            }}
          >
            <div
              className="w-14 h-14 rounded-full bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center"
              style={{
                boxShadow: '0 0 20px rgba(0, 229, 209, 0.4)',
              }}
            >
              <feature.icon className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-white text-center">{feature.title}</h3>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
